let hasInitialized = false;

const withPendo = (callback) => {
  const temp = setInterval(() => {
    const pendo = window?.pendo;
    if (!pendo) return;

    callback(pendo);
    clearInterval(temp);
  }, 300);
};

const ANON_ID_STORAGE_KEY = 'pendo_anon_id';

const getOrCreateAnonId = () => {
  try {
    let id = localStorage.getItem(ANON_ID_STORAGE_KEY);
    if (!id) {
      id = `anon-${crypto.randomUUID()}`;
      localStorage.setItem(ANON_ID_STORAGE_KEY, id);
    }
    return id;
  } catch {
    return `anon-${crypto.randomUUID()}`;
  }
};

const initializeAnonymousPendo = () => {
  withPendo((pendo) => {
    pendo.initialize({
      visitor: { id: getOrCreateAnonId() },
      account: { id: 'anonymous' },
    });
    hasInitialized = true;
  });
};

const initializePendo = (account) => {
  const payload = {
    visitor: {
      id: account.userId,
      email: account.email,
      full_name: `${account.firstName} ${account.lastName}`,
      App_Permission_Configuration: account.permissions.canSeeSettings,
    },
    account: {
      id: account.salesforceId || account.companyId,
      name: account.companyName,
    },
  };

  withPendo((pendo) => {
    if (hasInitialized) {
      pendo.identify(payload);
    } else {
      pendo.initialize(payload);
      hasInitialized = true;
    }
  });
};

export { initializePendo, initializeAnonymousPendo };
